import { setSearchValueAction as setSearchValueOperation } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/slice';

export default setSearchValueOperation;
